import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { HelpText } from '../Card';
import { COLOR, FONT_SIZE } from '../../../constants/theme';
import {
  ROUTE_PREFIX_PRE_APPT,
  ROUTES_PRE_APPT,
} from '../../../constants/routes';
import { getContactDetails } from '../../../utils/contactDetails';
import { getRescheduleBlockedMessage } from '../../../utils/rescheduleMessages';

const Prompt = styled.p`
  margin: 0;
  font-size: ${FONT_SIZE.body};
  color: ${COLOR.textMuted};
  text-align: center;
`;

// Reads as a link, but keeps a 44px tap target on phones.
const LinkButton = styled.button`
  min-height: 44px;
  padding: 0 4px;
  border: 0;
  background: none;
  font: inherit;
  font-weight: 600;
  color: ${COLOR.primary};
  text-decoration: underline;
  cursor: pointer;
`;

/**
 * Entry to the reschedule flow on the pre-appointment pages: a link when patient-api says
 * the appointment can be changed online, otherwise who to call. Nothing for an appointment
 * that is not booked or was cancelled; those pages already say what to do.
 */
const RescheduleEntry = ({ workflow }) => {
  const history = useHistory();
  const { workflowId } = useParams();
  const appointment = workflow?.appointment;

  if (!appointment?.isBooked || appointment?.isCancelled) return null;

  const reschedule = appointment.reschedule;

  if (reschedule?.eligible) {
    return (
      <Prompt>
        Need a different time?{' '}
        <LinkButton
          type="button"
          onClick={() =>
            history.push(
              `${ROUTE_PREFIX_PRE_APPT}/${workflowId}${ROUTES_PRE_APPT.RESCHEDULE}`
            )
          }
        >
          Reschedule your appointment
        </LinkButton>
      </Prompt>
    );
  }

  return (
    <HelpText>
      {getRescheduleBlockedMessage(
        reschedule?.reason,
        getContactDetails({ isAdhdPathway: workflow?.isAdhdPathway })
      )}
    </HelpText>
  );
};

export default RescheduleEntry;
